import { Controller } from "react-hook-form";

import { useTranslation } from "@shared/utils/internationalization";
import Checkbox from "@ui-kit/form/Checkbox/Checkbox.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import ParsedHtml from "@ui-kit/typography/ParsedHtml/ParsedHtml.web";
import { PublicVenueSerializer } from "@app-contexts/public/features/org-profile/data/types/public-venue";

function SubscribeCheckboxes({ venueData }: SubscribeCheckboxesProps) {
  const { t } = useTranslation("checkout");
  return (
    <Flex direction="column" gap="xs">
      <Flex direction="row" gap="xs" alignItems="center">
        <Controller
          name="subscribeToCompany"
          render={({ field }) => (
            <Checkbox
              checked={!!field.value}
              onCheckedChange={(details) => field.onChange(!!details.checked)}
            />
          )}
        />
        <Text style={{ flex: 1 }}>
          <Text as="span">{t("Subscribe to promotional emails from")}</Text>
          <Text as="span" fontWeight={700}>
            {" "}
            Showpass
          </Text>
        </Text>
      </Flex>
      {venueData?.name && (
        <Flex direction="column" gap="2xs">
          <Flex direction="row" gap="xs" alignItems="center">
            <Controller
              name="subscribeToVenue"
              render={({ field }) => (
                <Checkbox
                  checked={!!field.value}
                  onCheckedChange={(details) =>
                    field.onChange(!!details.checked)
                  }
                />
              )}
            />
            <Text style={{ flex: 1 }}>
              <Text as="span">{t("Subscribe to promotional emails from")}</Text>
              <Text as="span" fontWeight={700}>
                {" "}
                {venueData.name}
              </Text>
            </Text>
          </Flex>
          {venueData.subscription_message && (
            <Flex ml="2xl" color="gray.600">
              <ParsedHtml htmlString={venueData.subscription_message} />
            </Flex>
          )}
        </Flex>
      )}
    </Flex>
  );
}

export default SubscribeCheckboxes;

type SubscribeCheckboxesProps = {
  venueData?: PublicVenueSerializer;
};
